export default __webpack_public_path__ + "static/media/vehicleViewNext.96e07944.svg";